export default __webpack_public_path__ + "static/media/slick.c94f7671.ttf";